import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  Title
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, Title, ChartDataLabels);

export default function GraficoVolComTipo({ dados }) {
  const labels = dados ? dados.map(d => d.comp) : [];
  const valores = dados ? dados.map(d => d.qtd) : [];

  const data = {
    labels,
    datasets: [
      {
        label: 'Volume (Litros)',
        data: valores,
        backgroundColor: [
          'rgb(0, 168, 255)',   // blue-900
          'rgb(0, 168, 255)',   // blue-700
          'rgb(0, 168, 255)',  // blue-500
          'rgb(0, 168, 255)', // blue-300
          'rgb(0, 168, 255)', // gray-500
          'rgb(0, 168, 255)', // gray-400
        ],
        borderColor: '#ffffff',
        borderWidth: 2,
      },
    ],
  };

  const options = {
    indexAxis: 'y', // 🔑 transforma em barra horizontal
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: 'Volume (L) por Compartimento',
        font: { size: 16 },
        padding: { bottom: 20 }
      },
      datalabels: {
        color: '#fff',
        font: { weight: 'bold', size: 10 },
        formatter: (value) => {
          if (value === 0) return '';
          return value;
        },
      }
    },
  };

  return (
    <div className="bg-white p-4 shadow-sm rounded-lg h-80 flex flex-col items-center justify-center">
      {dados && dados.length > 0 ? (
        <Bar data={data} options={options} />
      ) : (
        <p className="text-gray-400">Sem dados para exibir - Volume (L) por Compartimento</p>
      )}
    </div>
  );
}
